
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.461 4.894l1.814 1.518 1.949 4.729a.7.7 0 00.441.4l9.417 2.913a.719.719 0 00.711-.17.681.681 0 00.174-.697l-2.973-9.224a.697.697 0 00-.41-.433L9.772 2.033 8.21.243a.717.717 0 00-1.035-.04L3.42 3.88a.684.684 0 00.04 1.014zm12.291 6.413L11.01 6.662a.716.716 0 00-.998 0 .681.681 0 000 .977l4.742 4.646-6.346-1.964-1.706-4.14 2.816-2.758 4.23 1.667 2.004 6.217zm-8.12-9.599l.756.866L5.842 5.07l-.884-.74 2.675-2.62zM0 15.429h18v2.204H0z"}})])
          )
        }
      }
    